import * as React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../../router/Routes';
import ContainerTemplate from '../../../../widgets/template/Container';
import HorariosView from '../HorariosView';

const PanelHorariosModule = () => {
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );
  return (
    <ContainerTemplate
      active={ROUTES.panelHorarios}
      routes={[ROUTES.controlEstudios, ROUTES.horarios]}
      subtitle={entHorariosClasesStore.activo.nombre}
    >
      <HorariosView />
    </ContainerTemplate>
  );
};

export default PanelHorariosModule;
